// Sign-up form (email + password + mandatory Terms/Privacy consent). On
// success shows a "check your email" confirmation message (Supabase email
// confirmation must be enabled).
import { useState } from 'react';
import { useAuth } from './AuthContext';
import { MIN_PASSWORD_LENGTH } from '../lib/authLogic';

const legalLinkStyle = { color: 'var(--amber-text, var(--amber))' };

export default function SignUp() {
  const { signUp } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [agreed, setAgreed] = useState(false);
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  async function submit(e) {
    e?.preventDefault();
    if (busy || !agreed) return;
    setBusy(true);
    setError(null);
    const { error: err } = await signUp(email, password);
    setBusy(false);
    if (err) {
      setError(err);
    } else {
      setDone(true);
    }
  }

  if (done) {
    return (
      <div
        style={{
          background: 'rgba(52,211,153,0.1)',
          border: '1px solid rgba(52,211,153,0.3)',
          borderRadius: 10,
          padding: '14px 16px',
          fontSize: 13,
          lineHeight: 1.6,
          color: 'var(--green)',
        }}
      >
        ✓ Account created. Check your email to confirm your address, then come back and log in.
      </div>
    );
  }

  return (
    <form onSubmit={submit} style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      <input
        type="email"
        className="text-input"
        placeholder="Email"
        autoComplete="email"
        value={email}
        onChange={e => setEmail(e.target.value)}
        style={{ width: '100%' }}
      />
      <input
        type="password"
        className="text-input"
        placeholder={`Password (min ${MIN_PASSWORD_LENGTH} characters)`}
        autoComplete="new-password"
        value={password}
        onChange={e => setPassword(e.target.value)}
        style={{ width: '100%' }}
      />
      {error && <div style={{ color: 'var(--red)', fontSize: 12 }}>{error}</div>}
      <label
        style={{
          display: 'flex',
          gap: 10,
          alignItems: 'flex-start',
          fontSize: 11.5,
          lineHeight: 1.55,
          color: 'var(--text-2)',
          cursor: 'pointer',
        }}
      >
        <input
          type="checkbox"
          checked={agreed}
          onChange={e => setAgreed(e.target.checked)}
          aria-label="Agree to the Terms of Service and Privacy Policy"
          style={{ width: 16, height: 16, marginTop: 1, flexShrink: 0, cursor: 'pointer' }}
        />
        <span>
          I agree to the{' '}
          <a href="#terms" style={legalLinkStyle}>
            Terms of Service
          </a>{' '}
          and{' '}
          <a href="#privacy" style={legalLinkStyle}>
            Privacy Policy
          </a>
          . I understand that AI answers must be verified against official documentation before
          acting on them.
        </span>
      </label>
      <button
        type="submit"
        className="btn"
        disabled={busy || !agreed}
        style={{ background: 'linear-gradient(135deg, #22d3ee, #0891b2)', color: '#0b1220' }}
      >
        {busy ? 'Creating account…' : 'Create account'}
      </button>
    </form>
  );
}
